<template>
  <!-- square frame from IconImage + sync arrows from IconChange + check from IconCheck -->
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <rect x="2.3335" y="2.33337" width="17.3333" height="17.3333" rx="1.5" stroke="#1B294A"/>
    <g transform="translate(11 11) scale(0.62) translate(-14.87 -15.33)" stroke="#1B294A" stroke-width="1.6" stroke-linejoin="round">
      <path d="M27 12.0381L23.7033 15.3348L20.4067 12.0381"/>
      <path d="M23.7027 14.2643C23.7027 9.31388 19.6896 5.30078 14.7392 5.30078C11.1803 5.30078 8.10593 7.37481 6.65869 10.3801"/>
      <path d="M2.73633 18.6309L6.033 15.3342L9.32967 18.6309"/>
      <path d="M6.0334 16.4047C6.03339 21.3551 10.0465 25.3682 14.9969 25.3682C18.7105 25.3682 21.8966 23.1099 23.2568 19.8917"/>
    </g>
    <path transform="translate(11 11.1) scale(0.44) translate(-8.25 -7.75)" d="M4 7.5L7 10.5L12.5 5" stroke="#1B294A" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconSync'
}
</script>
